import { gql, useQuery } from '@apollo/client';

// Define the GraphQL query for fetching a department
const GET_ORG_DEPARTMENT = gql`
  query GetOrgDepartment($facultyId: ID!, $departmentId: ID!) {
    getOrgDepartment(facultyId: $facultyId, departmentId: $departmentId) {
      id
      abbreviation
      title
      effectiveFrom
      effectiveTo
      school
      isActive
      head {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      director {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      drcChair {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      drcSecretaries {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const useGetOrgDepartment = (
  facultyId: string,
  departmentId: string,
): any => {
  const { data, loading, error } = useQuery(GET_ORG_DEPARTMENT, {
    variables: { facultyId, departmentId },
  });

  return {
    data,
    loading,
    error,
  };
};
